import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideAuth, LogLevel, StsConfigHttpLoader, StsConfigLoader } from 'angular-auth-oidc-client';
import { map } from 'rxjs/operators';

import { AppComponent } from './app.component';
import { environment } from '../environments/environment';

import { CoreModule } from './core/core.module';
import { AuthModule } from './auth/auth.module';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { DynamicFormsModule } from './shared/dynamic-forms/dynamic-forms.module';
import { RoutesModule } from './routes/routes.module';
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { ChatStyleModule } from './chatstyle/chatstyle.module';

import { DirtyGuardService } from './shared/dirty-guard/dirty-guard.service';

import { NgxStripeModule } from 'ngx-stripe';

import { CustomAuthInterceptor } from './core/interceptors/custom-auth.interceptor';

// https://github.com/ocombe/ng2-translate/issues/218
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function authConfigFactory(httpClient: HttpClient) {
  const config$ = httpClient.get<any>('/configuration').pipe(
    map(config => ({
      configId: 'default',
      authority: config.authority,
      redirectUrl: window.location.origin + '/auth-callback',
      postLoginRoute: '/auth-callback',
      postLogoutRedirectUri: window.location.origin,
      clientId: config.client_id,
      scope: config.scope,
      responseType: 'code',
      silentRenew: true,
      useRefreshToken: true,
      ignoreNonceAfterRefresh: true,
      autoUserInfo: false,
      renewUserInfoAfterTokenRenew: false,
      renewTimeBeforeTokenExpiresInSeconds: 30,
      logLevel: environment.production ? LogLevel.None : LogLevel.Debug,
      customParamsAuthRequest: {
        provider: 'ChatLocal',
        hostname: 'chat'
      },
      customParamsEndSessionRequest: {
        hostname: 'chat'
      },
      secureRoutes: [''],
    }))
  );

  return new StsConfigHttpLoader(config$);
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    NgxSpinnerModule,
    HttpClientModule,
    BrowserAnimationsModule, // required for ng2-tag-input
    CoreModule.forRoot(),
    AuthModule.forRoot(),
    ChatStyleModule.forRoot(),
    SharedModule.forRoot(),
    DynamicFormsModule.forRoot(), // Register Formly validators/types/wrappers at root level
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    LayoutModule,
    RoutesModule,
    NgxStripeModule.forRoot(environment.stripe.key)
  ],
  providers: [
    NgxSpinnerService,
    DirtyGuardService,
    { provide: HTTP_INTERCEPTORS, useClass: CustomAuthInterceptor, multi: true },
    provideAuth({
      loader: {
        provide: StsConfigLoader,
        useFactory: authConfigFactory,
        deps: [HttpClient],
      },
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
